module.exports = __webpack_public_path__ + "img/mastercard.543bc93b.svg";